@if (running) {
	<div>
		<div>
			<div class="loading-indicator"><spinner [color]="color" [diameter]="size" /></div>
		</div>
	</div>
}
